/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import { Button, Menu, Icon } from 'semantic-ui-react'
import _ from 'lodash';
import { FlyToInterpolator } from 'react-map-gl';
import * as d3 from 'd3-ease'

export default class Buttons extends PureComponent {


  _zoomOut = () => {
    this.props.onViewportChange({
      zoom: this.props.viewport.zoom - 5,
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 400,
      transitionEasing: d3.easeCubicIn,
    });
  }

  _zoomIn = () => {
    this.props.onViewportChange({
      zoom: this.props.viewport.zoom + 5,
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 400,
      transitionEasing: d3.easeCubicIn,
    });
  }

  render() {

    // const { zoomOut, viewport, renderLines, loadingLines, features, renderedSessions } = this.props;

    // const sessionsCouldRender = _.difference(features, renderedSessions )

    return (

      <div style={{position: 'absolute', bottom: 50, right: 50, maxWidth: 200, maxHeight: '80%',overflow: 'auto'}}>
        <Menu icon vertical >

        <Menu.Item onClick={this._zoomIn}>
          <Icon name='plus' size='small'/>
        </Menu.Item>

        <Menu.Item onClick={this._zoomOut}>
          <Icon name='minus' size='small'/>
        </Menu.Item>

      </Menu>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/buttons.js